import React from "react";
import classNames from "classnames";
import Button from "components/primary-button/button";
import styles from "./rebate-funds.module.scss";
import { successIcon } from "base/SVG";

export default function CreateRefCodeSuccess({ setModal }) {
  return (
    <>
      <div className={styles["modal__icon"]}>{successIcon}</div>
      <div className={classNames(styles["modal__title"], styles["sm"])}>
        <h4>Your Referral Code has been created successfully!</h4>
        <p>You can now share this code with your friends and earn rewards.</p>
      </div>
      <div className={classNames(styles["modal__foot"], styles["center"])}>
        <Button
          onClick={() => setModal(null)}
          text={"Go to Dashboard"}
          type={"primary"}
        />
      </div>
    </>
  );
}
